import { jsx as _jsx } from "react/jsx-runtime";
import { AppRoutes } from "./routes";
import Layout from "./components/Layout/Layout";
export default function App() {
    return (_jsx(Layout, { children: _jsx(AppRoutes, {}) }));
}
